import { makeStyles } from '@material-ui/core'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%'
  },
  upSection: {
    display: 'grid',
    gridTemplateColumns: ' 1fr',
    gap: 20
  },
  upLeftSide: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 40
  },
  upRightSide: {},
  downSection: {
    display: 'flex',
    flexDirection: 'row-reverse',
    gap: 6,
    marginTop: 32,
    marginBottom: 16
  },
  filterButton: {
    borderRadius: 4,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    }
  },
  resetFilterButton: {
    borderRadius: 4,
    backgroundColor: theme.palette.grey[200],
    color: theme.palette.primary.dark,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: theme.palette.grey[200],
      color: theme.palette.primary.dark
    }
  }
}))

export default useStyles
